import { Component, ViewEncapsulation } from '@angular/core';
import { CoreConfigService } from '@core/services/config.service';
import { fadeInLeft, zoomIn, fadeIn } from '@core/animations/core.animation';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { openInNewTab } from 'app/shared/functions/functions';

@Component({
  selector: 'content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [fadeInLeft, zoomIn, fadeIn]
})
export class ContentComponent {
  public coreConfig: any;
  public animate;  
  public dpoLogoH: number = 80;
  public dpoLogo: string = "assets/images/logo/dpo-logo.png";
  public showDpoLogo: boolean = false;
  private resizeRaf: number | null = null;
  public sidcDataPrivacyUrl: string = "https://sidc.coop/data-privacy";
  public showDpoUrls: string[] = [
    "/auth/login", "/auth/activate", "/auth/register", "/main-page", "/gam", "/gam/pre-register"
  ]

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   *
   */
  constructor(private _coreConfigService: CoreConfigService, private _router: Router) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  /**
   * Fade In Left Animation
   *
   * @param outlet
   */
  fadeInLeft(outlet) {
    if (this.animate === 'fadeInLeft') {
      return outlet.activatedRouteData.animation;
    }
    return null;
  }

  /**
   * Zoom In Animation
   *
   * @param outlet
   */
  zoomIn(outlet) {
    if (this.animate === 'zoomIn') {
      return outlet.activatedRouteData.animation;
    }
    return null;
  }

  /**
   * Fade In Animation
   *
   * @param outlet
   */
  fadeIn(outlet) {
    if (this.animate === 'fadeIn') {
      return outlet.activatedRouteData.animation;
    }
    return null;
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit(): void {
    // Subscribe config change
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      this.animate = this.coreConfig.layout.animation;
    });
    
    this._router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        const currentUrl = this._router.url;
        this.showDpoLogo = this.showDpoUrls.includes(currentUrl) || currentUrl.includes("/member-gam");
        const dpoLogoR = !currentUrl.includes("/member-gam") ? 20 : 10;
        document.documentElement.style.setProperty("--dpoLogoR",`${dpoLogoR}px`);
      }
    });
    fromEvent(window, "resize")
      .subscribe(() => {
        if (this.resizeRaf) {
          cancelAnimationFrame(this.resizeRaf);
        }

        this.resizeRaf = requestAnimationFrame(() => {
          const screenW = window.innerWidth;          
          this.dpoLogoH = screenW <= 340.98 ? 100 : 110;
        });
      });
  }
}
